import { render } from "./TeacherHome.vue?vue&type=template&id=6b589f1f&scoped=true"
import script from "./TeacherHome.vue?vue&type=script&lang=js"
export * from "./TeacherHome.vue?vue&type=script&lang=js"

import "./TeacherHome.vue?vue&type=style&index=0&id=6b589f1f&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b589f1f"]])

export default __exports__